import $ from 'jquery';

$(_ => {

  const $form = $('#form-cart-donation');
  if ($form.length === 0) return;

  const $radios = $form.find('input[type=radio]');
  const $amount = $form.find('#input-amount');
  const $btnSubmit = $form.find('#form-cart-donation--btn-submit');

  $radios.on('mousedown touchstart keydown', event => {

    let inverseEvent;
    switch (event.type) {
      case 'mousedown':
        inverseEvent = 'mouseup';
        break;
      case 'touchstart':
        inverseEvent = 'touchend';
        break;
      case 'keydown':
        inverseEvent = 'keyup';
        break;
    }

    const $radio = $(event.target);
    const isChecked = $radio.is(':checked');
    if (!isChecked) {
      $radio.one(inverseEvent, _ => {
        window.setTimeout(_ => {
          if ($radio.is(':checked') !== isChecked) {
            $amount.val('');
          }
        }, 1);
      });
    }
  });
  $amount.on('change number-value-change', _ => {
    window.setTimeout(_ => {
      if ($amount.val()) {
        $radios.attr('checked', false);
      }
      $form.trigger('change');
    }, 1);
  });

  $form.on('change', _ => {
    const valid = parseInt($amount.val(), 10) || $radios.filter(':checked').val();
    if (valid) {
      $btnSubmit.removeAttr('disabled');
    } else {
      $btnSubmit.attr('disabled', 'disabled');
    }
  });


});